<template>
    <suspense>
        <router-view />
        <template #fallback>
            <spinner-loader />
        </template>
    </suspense>
</template>
